<template>
    <svg :class="svgClass" id="Layer_1" xmlns="http://www.w3.org/2000/svg" x="0" y="0" viewBox="0 0 48 48"><g id="_x31_.-Foundations_x2F_Icons_x2F_ATAS_x5F_Icon_x5F_Airplay_00000065793492796835552030000003839999132349011877_"><path id="Combined-Shape_00000118385226632644215430000012735393000106897025_" class="st0" d="M40 7c2.2 0 4 1.8 4 4v20c0 2.2-1.8 4-4 4H4.1v-4H40V11H8v12c0 2.2-1.8 4-4 4V11c0-2.2 1.8-4 4-4h32z" /></g><path class="st0" d="M22 35h4v8h-4z" /><path class="st0" d="M12 39h24v4H12z" /></svg>
</template>

<script>
export default {
    name: 'television',
    props: {
        svgClass: {
            type: String,
            default: 'svg-24'
        },
    }
}
</script>
